module.exports = __webpack_public_path__ + "static/3-7c90d1c47b993ac6a0d0c2dbcbb0db50.png";